var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { class: { "brdr-top-1 brdr-cl-secondary": _vm.isCheckoutPage } },
    [
      !_vm.isCheckoutPage
        ? _c("newsletter", { staticClass: " flex brdr-bottom-1 brdr-cl-dark" })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCheckoutPage
        ? _c(
            "div",
            {
              staticClass: "footer-links flex pt30 pb60 px40 bg-cl-transparent"
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row m0 center-xs between-md" }, [
                  _c("div", { staticClass: "col-12 col-lg-2 col-xl-2" }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile"
                    },
                    [
                      _c("cms-block-menu", {
                        attrs: {
                          identifier: "m_FOOTER_MENU_ABOUT",
                          "li-class": "footer-links__elem",
                          "ul-class": "footer-links__list"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile"
                    },
                    [
                      _c("cms-block-menu", {
                        attrs: {
                          identifier: "m_FOOTER_MENU_PRODUCT",
                          "li-class": "footer-links__elem",
                          "ul-class": "footer-links__list"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile"
                    },
                    [
                      _c("cms-block-menu", {
                        attrs: {
                          identifier: "m_FOOTER_MENU_SECURITY",
                          "li-class": "footer-links__elem",
                          "ul-class": "footer-links__list"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "footer-links__box col-12 col-sm-6 col-lg start-md between-md between-xs no-mobile"
                    },
                    [
                      _c("cms-block-menu", {
                        attrs: {
                          identifier: "m_FOOTER_MENU_ACCOUNT",
                          "li-class": "footer-links__elem",
                          "ul-class": "footer-links__list"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-lg-2 col-xl-1" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row social mt30" })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "py15 px25 brdr-top-1 brdr-cl-secondary bg-cl-white footer-bottom",
          staticStyle: { display: "flex", "justify-content": "flex-end" }
        },
        [_c("cms-block-chunk", { attrs: { identifier: "c_POWERED_BY" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "back-to-top",
        { attrs: { bottom: _vm.bottom, right: "20px", visibleoffset: "200" } },
        [
          _c(
            "button",
            {
              staticClass:
                "btn-top button no-outline brdr-none cl-white bg-cl-mine-shaft :bg-cl-th-secondary py10 px10",
              attrs: { type: "button" }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "24",
                    height: "24",
                    xmlns: "http://www.w3.org/2000/svg",
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z",
                      fill: "white"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-lg-2 col-xl-3 footer__logo-wrapper" },
      [
        _c("img", {
          attrs: { src: "/assets/blackpoint-logo.svg", alt: "footer logo" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "footer__copy m0" }, [
          _vm._v("Copyright © 2021")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }